import { flags } from '@/assets';

/**
 * Cómo es un celular en cada país que se puede elegir en el selector de
 * prefijo.
 *
 * El usuario escribe solo `length` dígitos: el prefijo internacional va en el
 * selector y `mobilePrefix` (el dígito con que arranca todo celular del país,
 * como el 9 de Uruguay y Perú) se muestra fijo al lado. `trunkPrefix` es el 0
 * del formato local (`09…`): se acepta al pegar el número completo y en el
 * país del panel se sigue anteponiendo al guardar.
 */
export interface PhoneCountry {
  code: string;
  label: string;
  dialCode: string;
  flag: string;
  mobilePrefix: string;
  trunkPrefix: string;
  length: number;
}

export const PHONE_COUNTRIES: readonly PhoneCountry[] = [
  {
    code: 'uy',
    label: 'Uruguay',
    dialCode: '598',
    flag: flags.uy,
    mobilePrefix: '9',
    trunkPrefix: '0',
    length: 7,
  },
  {
    code: 'pe',
    label: 'Perú',
    dialCode: '51',
    flag: flags.pe,
    mobilePrefix: '9',
    trunkPrefix: '',
    length: 8,
  },
  {
    code: 'ar',
    label: 'Argentina',
    dialCode: '54',
    flag: flags.ar,
    mobilePrefix: '9',
    trunkPrefix: '',
    length: 10,
  },
  {
    code: 'bo',
    label: 'Bolivia',
    dialCode: '591',
    flag: flags.bo,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 8,
  },
  {
    code: 'br',
    label: 'Brasil',
    dialCode: '55',
    flag: flags.br,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 11,
  },
  {
    code: 'cl',
    label: 'Chile',
    dialCode: '56',
    flag: flags.cl,
    mobilePrefix: '9',
    trunkPrefix: '',
    length: 8,
  },
  {
    code: 'co',
    label: 'Colombia',
    dialCode: '57',
    flag: flags.co,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 10,
  },
  {
    code: 'ec',
    label: 'Ecuador',
    dialCode: '593',
    flag: flags.ec,
    mobilePrefix: '9',
    trunkPrefix: '0',
    length: 8,
  },
  {
    code: 'es',
    label: 'España',
    dialCode: '34',
    flag: flags.es,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 9,
  },
  {
    code: 'us',
    label: 'Estados Unidos',
    dialCode: '1',
    flag: flags.us,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 10,
  },
  {
    code: 'mx',
    label: 'México',
    dialCode: '52',
    flag: flags.mx,
    mobilePrefix: '',
    trunkPrefix: '',
    length: 10,
  },
  {
    code: 'py',
    label: 'Paraguay',
    dialCode: '595',
    flag: flags.py,
    mobilePrefix: '9',
    trunkPrefix: '0',
    length: 8,
  },
  {
    code: 've',
    label: 'Venezuela',
    dialCode: '58',
    flag: flags.ve,
    mobilePrefix: '4',
    trunkPrefix: '0',
    length: 9,
  },
];

export const findPhoneCountry = (
  code: string | null | undefined
): PhoneCountry | undefined =>
  PHONE_COUNTRIES.find((country) => country.code === code);

export const PHONE_COUNTRIES_BY_DIAL_LENGTH: readonly PhoneCountry[] = [
  ...PHONE_COUNTRIES,
].sort((a, b) => b.dialCode.length - a.dialCode.length);
